// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ny5a","rootMobile":"styles_rootMobile__3PZAb"};